import React from "react";
import { useSelector } from "react-redux";

import moment from "moment";

import CommunityCommentExample from "../../comment/CommunityCommentExample";
import CommunityFavorite from "../CommunityFavorite";

const CommunityEachBoardType = ({ item, handleCommentMove }) => {
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);

	if (reduxChannel?.user_id) {
		return (
			<>
				<div className={`community-each-component-title-div`}>
					<img
						src={`${process.env.REACT_APP_S3_HOST}/image/together/profile_${item?.created_by}.${item?.profile_img_type}`}
						// src={`/assets/images/channel/doctor.png`}
						onError={({ currentTarget }) => {
							currentTarget.onerror = null; // prevents looping
							// currentTarget.style.display = "none";
							currentTarget.src = `/assets/images/channel/basic.png`;
						}}
						alt={`채널 이미지`}
						className={`community-each-component-title-image`}
					/>
					<div className={`community-each-component-nickname-time-div`}>
						<div className={`nickname-div`}>
							<p className={`nickname`}>
								{/*{reduxChannel?.nickname}*/}
								{item?.created_by_name ?? reduxChannel?.nickname}
							</p>
							<p
								className={`gray category`}
								style={{
									backgroundColor: `${item?.background_color}`,
									marginLeft: "auto",
								}}
							>
								{item?.category_name}
							</p>
						</div>
						<p className={`gray`}>
							{moment(item?.created_at).format("M월 D일")}
						</p>
					</div>
				</div>

				<div className={`community-each-component-body-div board-type`}>
					<p
						style={
							item?.communityImageList?.length
								? {}
								: {
										width: "100%",
								  }
						}
					>
						{/*<b>*/}
						{item?.title ? `${item?.title} ` : ""}
						{/*</b>*/}
						{"\n"}
						{item?.body}
					</p>
					{item?.body?.split("\n")?.length - 1 >= 5 && (
						<p className={`gray`}>...더보기</p>
					)}

					{!!item?.communityImageList?.length && (
						<div className={`community-each-component-image-div`}>
							{item?.communityImageList?.map((src, idx) => {
								return (
									<div
										// className={`${!!imgBool ? "community-image-each width-more" : "community-image-each"}`}
										className={`${`community-image-each width-more`}`}
										id={`image-${item?.communityImageList?.length}`}
										key={`community-image-${idx}`}
									>
										<img
											src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${reduxChannel?.user_id}/${src?.title}.${src?.img_type}`}
											onError={({ currentTarget }) => {
												currentTarget.onerror = null; // prevents looping
												// currentTarget.style.display = "none";
												// currentTarget.src = `/assets/images/no-product.png`;
											}}
											alt={`게시판 이미지`}
										/>
									</div>
								);
							})}
						</div>
					)}
				</div>

				<CommunityFavorite
					item={item}
					handleCommentMove={(e) => handleCommentMove(e, item)}
					type={"example"}
				/>

				{item?.commentList?.slice(0, 2)?.map((comment, idx) => (
					<div key={`comment-example-${idx}`}>
						<CommunityCommentExample comment={comment} />
					</div>
				))}
			</>
		);
	} else {
		return <></>;
	}
};

export default CommunityEachBoardType;
